import React from "react";
import { motion, useScroll, useSpring } from "framer-motion";

// Thin sacred gold progress rail at the very top of the viewport.
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 140, damping: 26, restDelta: 0.001 });

  return (
    <motion.div
      style={{ scaleX }}
      className="fixed left-0 top-0 z-[100] h-[3px] w-full origin-left bg-gradient-to-r from-tara-vermilion via-tara-gold to-tara-goldAccent"
      data-testid="scroll-progress"
    />
  );
}
